export default __webpack_public_path__ + "static/media/ref.dbace400.svg";